import React from 'react';
import { Navigate } from 'react-router-dom';
import { LazyPage } from '@hocs';
import { Routes } from '@enums';
import { jsx as _jsx } from "react/jsx-runtime";
var HomePage = LazyPage('home', 'HomePage');
var GroupsPage = LazyPage('groups', 'GroupsPage');
var LogPage = LazyPage('log', 'LogPage');
var SettingsPage = LazyPage('settings', 'SettingsPage');
var WisperUsersPage = LazyPage('wisper-users', 'WisperUsersPage');
var appPrivateRoutes = [{
  name: Routes.Main,
  path: Routes.Main,
  element: /*#__PURE__*/_jsx(Navigate, {
    to: Routes.Home,
    replace: true
  }),
  index: false
}, {
  name: Routes.Home,
  path: Routes.Home,
  element: /*#__PURE__*/_jsx(HomePage, {}),
  index: false,
  inline: true
}, {
  name: Routes.Groups,
  path: Routes.Groups,
  element: /*#__PURE__*/_jsx(GroupsPage, {}),
  index: false,
  inline: true
}, {
  name: Routes.Log,
  path: Routes.Log,
  element: /*#__PURE__*/_jsx(LogPage, {}),
  index: false,
  inline: true
}, {
  name: Routes.Settings,
  path: Routes.Settings,
  element: /*#__PURE__*/_jsx(SettingsPage, {}),
  index: false,
  inline: false
}, {
  name: Routes.WisperUsers,
  path: Routes.WisperUsers,
  element: /*#__PURE__*/_jsx(WisperUsersPage, {}),
  index: false,
  inline: true
}];
export { appPrivateRoutes };